import React, { useState } from "react";
import { Link } from "react-router-dom";
import translate from "../../service/Language";
import Cart from "../Cart/Cart";
import Checkout from "../Checkout/Checkout";
import classes from "./Navbar.module.css";

function Navbar({
  language,
  setLanguage,
  getLang,
  home,
  GetHome,
  productNumbers,
  productsInCart,
  totalCoastGet,
  minusNumber,
  cartNumbers,
  toggle,
  setToggle,
  checkout,
  setCheckout,
  oneClick,
  setOneClick,
  oneClickProduct,
  setOneClickProduct,
  GetPage,
  mediaBars,
  setMediaBars
}) {


  const [bars, setBars] = useState(false)

  const smallNavbarTrue = () => {
    setBars(true);
    document.body.style.overflow = "hidden";
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  const smallNavbarFalse = () => {
    setBars(false);
    document.body.style.overflow = "scroll";
  };

  return (
    <>
      <div className={classes.Navbar}>
        <div className={classes.left}>
          <Link
            to={"/"}
            onClick={(e) => {
              GetHome();
            }}
          >
            <img src="/images/logo.png" alt="" />
          </Link>
        </div>
        <div className={classes.right}>
          {window.innerWidth <= 600 ? (
            <>
              {mediaBars ? <div
                className={`${classes.bars} ${bars ? classes.active : ""}`}
                onClick={(e) => {
                  bars ? smallNavbarFalse() : smallNavbarTrue();
                }}
              >
                <div className={classes.line}></div>
                <div className={classes.line}></div>
                <div className={classes.line}></div>
              </div> : ""}

              <div
                className={`${classes.navbar_small} ${bars ? classes.activeNavbar : ""
                  }`}
              >
                {bars ? (
                  <>
                    <ul>
                      <li>
                        {" "}
                        <Link
                          onClick={(e) => {
                            GetHome();
                            GetPage(e);
                            smallNavbarFalse();
                          }}
                          to={home ? "#catalog" : "/catalog"}
                        >
                          {translate("КАТОЛОГ", "KATALOG")}
                        </Link>{" "}
                      </li>
                      <li>
                        {" "}
                        <Link
                          onClick={(e) => {
                            GetHome();
                            GetPage(e);
                            smallNavbarFalse();
                          }}
                          to={home ? "#reviews" : "/reviews"}
                        >
                          {translate("ОТЗЫВЫ", "SHARHLAR")}
                        </Link>{" "}
                      </li>
                      <li>
                        {" "}
                        <Link
                          onClick={(e) => {
                            GetHome();
                            GetPage(e);
                            smallNavbarFalse();
                          }}
                          to={home ? "#contact" : "/contact"}
                        >
                          {translate("КОНТАКТЫ", "ALOQA")}
                        </Link>{" "}
                      </li>

                      <li className={classes.lang}>
                        <select
                          name=""
                          id=""
                          value={language ? language : ""}
                          onChange={(e) => {
                            localStorage.setItem("language", e.target.value);
                            setLanguage(e.target.value);
                            getLang();
                          }}
                        >
                          <option value="uz">UZ</option>
                          <option value="ru">RU</option>
                        </select>
                      </li>
                      <li
                        className={classes.cart}
                        onClick={(e) => {
                          setToggle(true);
                          setMediaBars(false)
                        }}
                      >
                        <svg
                          width="20"
                          height="22"
                          viewBox="0 0 20 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.67929 20.8598H0.499023V4.50195H3.73406"
                            stroke="#333333"
                            strokeMiterlimit="3.8637"
                          />
                          <path
                            d="M5.89062 5.18856C5.89062 5.18856 5.89062 5.36384 5.89062 3.76822C5.89062 2.17355 7.09758 0.880859 8.58649 0.880859C10.0754 0.880859 11.2824 2.17355 11.2824 3.76822C11.2824 5.36288 11.2824 5.18856 11.2824 5.18856"
                            stroke="#333333"
                            strokeMiterlimit="3.8637"
                          />
                          <path
                            d="M3.75879 4.50195H19.499V20.8598H3.75879V4.50195Z"
                            fill="#8b51fd"
                          />
                          <path
                            d="M3.75879 4.50195H19.499V20.8598H3.75879V4.50195Z"
                            stroke="black"
                            strokeMiterlimit="3.8637"
                          />
                          <path
                            d="M9.12598 6.27259C9.12598 6.27259 9.12598 4.90562 9.12598 3.47365C9.12598 2.04167 10.3329 0.880859 11.8218 0.880859C13.3108 0.880859 14.5177 2.04167 14.5177 3.47365C14.5177 4.90562 14.5177 6.27259 14.5177 6.27259"
                            stroke="#333333"
                            strokeMiterlimit="3.8637"
                          />
                        </svg>
                        <span>{productNumbers ? productNumbers : 0}</span>
                      </li>
                    </ul>
                    <div className={classes.Cart}>
                      {toggle ? (
                        <Cart setMediaBars={setMediaBars}
                          setCheckout={setCheckout}
                          productNumbers={productNumbers}
                          cartNumbers={cartNumbers}
                          minusNumber={minusNumber}
                          totalCoastGet={totalCoastGet}
                          productsInCart={productsInCart}
                          setToggle={setToggle}
                          smallNavbarFalse={smallNavbarFalse}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
              {bars ? (
                <>
                  <div
                    className={classes.bg_navbar}
                    onClick={(e) => {
                      smallNavbarFalse();
                    }}
                  ></div>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              <ul>
                <li>
                  {" "}
                  <Link
                    onClick={(e) => {
                      GetHome();
                      GetPage(e);
                    }}
                    to={home ? "#catalog" : "/catalog"}
                  >
                    {translate("КАТОЛОГ", "KATALOG")}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    onClick={(e) => {
                      GetHome();
                      GetPage(e);
                    }}
                    to={home ? "#reviews" : "/reviews"}
                  >
                    {translate("ОТЗЫВЫ", "SHARHLAR")}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    onClick={(e) => {
                      GetHome();
                      GetPage(e);
                    }}
                    to={home ? "#contact" : "/contact"}
                  >
                    {translate("КОНТАКТЫ", "ALOQA")}
                  </Link>{" "}
                </li>

                <li className={classes.lang}>
                  <select
                    name=""
                    id=""
                    value={language ? language : ""}
                    onChange={(e) => {
                      localStorage.setItem("language", e.target.value);
                      setLanguage(e.target.value);
                      getLang();
                    }}
                  >
                    <option value="uz">UZ</option>
                    <option value="ru">RU</option>
                  </select>
                </li>
                <li
                  className={classes.cart}
                  onClick={(e) => {
                    setToggle(true);
                  }}
                >
                  <svg
                    width="20"
                    height="22"
                    viewBox="0 0 20 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.67929 20.8598H0.499023V4.50195H3.73406"
                      stroke="#333333"
                      strokeMiterlimit="3.8637"
                    />
                    <path
                      d="M5.89062 5.18856C5.89062 5.18856 5.89062 5.36384 5.89062 3.76822C5.89062 2.17355 7.09758 0.880859 8.58649 0.880859C10.0754 0.880859 11.2824 2.17355 11.2824 3.76822C11.2824 5.36288 11.2824 5.18856 11.2824 5.18856"
                      stroke="#333333"
                      strokeMiterlimit="3.8637"
                    />
                    <path
                      d="M3.75879 4.50195H19.499V20.8598H3.75879V4.50195Z"
                      fill="#8b51fd"
                    />
                    <path
                      d="M3.75879 4.50195H19.499V20.8598H3.75879V4.50195Z"
                      stroke="black"
                      strokeMiterlimit="3.8637"
                    />
                    <path
                      d="M9.12598 6.27259C9.12598 6.27259 9.12598 4.90562 9.12598 3.47365C9.12598 2.04167 10.3329 0.880859 11.8218 0.880859C13.3108 0.880859 14.5177 2.04167 14.5177 3.47365C14.5177 4.90562 14.5177 6.27259 14.5177 6.27259"
                      stroke="#333333"
                      strokeMiterlimit="3.8637"
                    />
                  </svg>
                  <span>{productNumbers ? productNumbers : 0}</span>
                </li>
              </ul>
              <div className={classes.Cart}>
                {toggle ? (
                  <Cart
                    setCheckout={setCheckout}
                    productNumbers={productNumbers}
                    cartNumbers={cartNumbers}
                    minusNumber={minusNumber}
                    totalCoastGet={totalCoastGet}
                    productsInCart={productsInCart}
                    smallNavbarFalse={smallNavbarFalse}
                    setToggle={setToggle}
                    setMediaBars={setMediaBars}
                  />
                ) : (
                  ""
                )}
              </div>
            </>
          )}
        </div>
      </div>
      {toggle || checkout ? (
        <div
          className={classes.bg}
          onClick={(e) => {
            setToggle(false);
            setCheckout(false);
            setOneClick("");
            setOneClickProduct("");
          }}
        ></div>
      ) : (
        ""
      )}
      {checkout ? (
        <Checkout
          oneClickProduct={oneClickProduct}
          setOneClickProduct={setOneClickProduct}
          oneClick={oneClick}
          setOneClick={setOneClick}
          productsInCart={productsInCart}
          totalCoastGet={totalCoastGet}
          setToggle={setToggle}
          setCheckout={setCheckout}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Navbar;
